import type { SVGProps } from 'react';
const SvgIconClear = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
    <path
      fill="currentColor"
      d="M9.768 10.828 8 9.061l-1.768 1.767a.75.75 0 1 1-1.06-1.06L6.939 8 5.172 6.232a.75.75 0 0 1 1.06-1.06L8 6.939l1.768-1.767a.75.75 0 1 1 1.06 1.06L9.061 8l1.767 1.768a.75.75 0 1 1-1.06 1.06"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.942 16h.116c.408 0 .687 0 .933-.016a7.5 7.5 0 0 0 6.993-6.993C16 8.745 16 8.466 16 8.058v-.116c0-.408 0-.687-.016-.933A7.5 7.5 0 0 0 8.99.016 15 15 0 0 0 8.058 0h-.116c-.408 0-.687 0-.933.016A7.5 7.5 0 0 0 .016 7.01C0 7.255 0 7.534 0 7.942v.116c0 .408 0 .687.016.933a7.5 7.5 0 0 0 6.993 6.993c.246.016.525.016.933.016M1.5 8c0-.464 0-.696.013-.892a6 6 0 0 1 5.595-5.595C7.304 1.5 7.536 1.5 8 1.5s.696 0 .892.013a6 6 0 0 1 5.595 5.595c.013.196.013.428.013.892s0 .696-.013.892a6 6 0 0 1-5.595 5.595c-.196.013-.428.013-.892.013s-.696 0-.892-.013a6 6 0 0 1-5.595-5.595C1.5 8.696 1.5 8.464 1.5 8"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgIconClear;
